import { useCallback, useState } from 'react';

import { SCROLL_THRESHOLD } from './constants';

export const useContentScroll = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback(event => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const isScrollable = scrollHeight > clientHeight;
    const isAtBottom = scrollHeight - scrollTop - clientHeight < SCROLL_THRESHOLD;

    setIsScrolled(isScrollable && !isAtBottom);
  }, []);

  return { isScrolled, handleScroll };
};
